/* eslint-disable no-unreachable */
/* eslint-disable no-console */
/* eslint-disable max-len */
import { Menu, MenuItem } from '@mui/material';
import { RiFileUploadLine } from 'react-icons/ri';
import { BsFolderPlus } from 'react-icons/bs';
import React, { useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LanguageContext } from '../../../../libs/Context';
import NewFolderCreation from '../NewFolderCreation';
import UploadFolder from '../../Common/UploadFolder';
import { MediaContext } from '../..';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { MuiPaperProps, catchErr, roleCondition } from '../../../../libs/HelperContent';
import useUpdateStorage from '../../../LicenseSubscription/customHooks/useGetStorage';
import MDSelectFiles from '../../popups/MDSelectFiles';
import TemplatesSvg from '../../../../assets/SvgComponents/TemplatesSvg';
import SelectTemplate from '../CustomEdmTemplates/SelectTemplate';

const FolderMenuNew = ({ uploadFilesFunc, uploadFolderFunc, menuItem, anchorEl, tab, setOpen }) =>
{
	const navigate = useNavigate();
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { clickedData, setMediaState } = useContext(MediaContext);
	const tabVal = tab === 1 ? 'shared' : tab === 2 ? 'employee' : tab === 3 ? 'trash' : tab === 4 ? 'template' : 'folder';
	const folderId = useParams()?.id || '';
	const [ isPopupOpen, setIsPopupOpen ] = useState(false);
	const [ openCreateFolder, setOpenCreateFolder ] = useState(false);
	const setStorageData = useUpdateStorage();
	const [ createDesign, setCreateDesign ] = useState(false);

	const handleOpenCreateFolder = () =>
	{
		setOpenCreateFolder(true);
	};
	const handleCloseCreateFolder = () =>
	{
		setOpenCreateFolder(false);
	};
	const handleClose = () =>
	{
		setMediaState({ type: 'setMenuItems', payload: { create: menuItem?.create === 0 ? 1 : 0 } });
	};

	const handleUpload = async (fileList) =>
	{
		if (fileList?.length > 10)
		{
			toast.error(language?.cannot10Files, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});

			return;
		}
		if (fileList.length === 0) return;
		const size:number = fileList.reduce((total:number, item:any) => total + item?.size, 0);
		const checkRole = roleCondition(userData?.empRole);
		const ownerCompanyId = tab === 1 ? clickedData?.companyId : userData?.companyId;

		setStorageData({ action: 'add', size, ownerCompanyId })
			.then((lic) =>
			{
				if (lic)
				{
					if (lic?.statusCode === 507)
					{
						setOpen(checkRole && true);
					}
					else
					{
						uploadFilesFunc(fileList);
					}
				}
				setMediaState({ type: 'setMenuItems', payload: { create: 0 } });
			})
			.catch((err) => catchErr(err));
	};

	const handleUploadFiles = () => { setIsPopupOpen(true); };
	const handleClosePopUp = () => { setIsPopupOpen(false); };
	const onDrop = (acceptedFiles) =>
	{
		handleUpload(acceptedFiles);
		handleClose();
	};

	const closePopUP = () =>
	{
		handleClosePopUp();
		handleClose();
	};
	const handleCloseDesign = () =>
	{
		setCreateDesign(false);
	};
	const handleOpenDesign = () =>
	{
		setCreateDesign(true);
	};

	return (
		<>
			<Menu
				anchorEl={anchorEl}
				id='account-menu'
				open={menuItem?.create === 1}
				onClose={handleClose}
				PaperProps={MuiPaperProps}
				transformOrigin={{
					vertical   : 'top',
					horizontal : 160
				}}
				anchorOrigin={{
					vertical   : 248,
					horizontal : 'right'
				}}
			>
				<MenuItem tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleOpenCreateFolder(); }} onClick={handleOpenCreateFolder}>
					<div className='flexInline pdngXXS'>
						<BsFolderPlus fontSize={'var(--pixel24)'} className='lightTxt' />
						<span className='pdngLXS'>{language?.createFolder}</span>
					</div>
				</MenuItem>
				<MenuItem tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleOpenDesign(); }} onClick={handleOpenDesign} className='menucard noPdng'>
					<div className='flexInline menuIconPdng pointer'>
						<img src='/images/icons/editgrey.svg' alt='editBrush' className='imgAvatarXXS lightTxt'/>
						<span className='pdngLXS'>{language?.createDesign}</span>
					</div>
				</MenuItem>
				{/* // previously create design is there now text is replace with create template */}
				{roleCondition(userData?.empRole) && <MenuItem tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && navigate(folderId ? `/drive/design/${tabVal}/${folderId}` : `/drive/design/${tabVal}`); }} onClick={() => navigate(folderId ? `/drive/design/${tabVal}/${folderId}` : `/drive/design/${tabVal}`)} className='menucard noPdng'>
					<div className='flexInline menuIconPdng pointer'>
						<span className='imgAvatarXXS lightTxt'><TemplatesSvg data-tab='template'/></span>
						<span className='pdngLXS capitalTxt'>{language?.createTemp}</span>
					</div>
				</MenuItem>}
				<UploadFolder
					uploadFolderFunc={uploadFolderFunc}
					setOpen={setOpen}
					setMediaState={setMediaState}
					tab={tab}
				/>
				<MenuItem className='menucard noPdng'>
					<div className='flexRow positionRelative'>
						<span className='flexInline pointer menuIconPdng' onClick={handleUploadFiles}>
							<RiFileUploadLine fontSize={'var(--pixel24)'} className='lightTxt' />
							<span className='pdngLXS'>{language?.uploadFiles}</span>
						</span>
					</div>
				</MenuItem>
			</Menu>
			{openCreateFolder && (
				<NewFolderCreation
					handleOpenCreateFolder={handleOpenCreateFolder}
					handleCloseCreateFolder={handleCloseCreateFolder}
					handleCloseMenu={handleClose}
				/>
			)}
			{isPopupOpen && (
				<MDSelectFiles
					closePopUP={closePopUP}
					onDrop={onDrop}
				/>
			)}
			{createDesign && <SelectTemplate handlePopup={handleCloseDesign} popups={createDesign} from='create'/>}

		</>
	);
};

export default FolderMenuNew;
